<!-- eslint-disable no-irregular-whitespace -->
<template>
  <page>
    <!-- car-content -->
    <div class="car-content">
      <div class="wrapper" v-if="!loading">

        <center>
          <div class="car-content-title">
            <span class="big red">
              {{ data.shop?.areaName ?? '全ての' }}エリア
            </span>のクルマ
          </div>
        </center>

        <div class="car-content-area sans">
          <center>
            <div class="car-content-in-title sans">
              {{ data.carName }}　{{ data.grade }}
            </div>
          </center>
        </div>

        <!-- 車種詳細 -->
        <div class="car-content-in">

          <!-- メイン画像 -->
          <ul class="car-content-in-list">
            <li v-for="path in data.imagePaths" :key="path">
              <img :src="path" width="920" height="547">
            </li>
          </ul>
          <!-- /メイン画像 -->

          <!-- 画像コメント -->
          <ul class="car-content-in-comment-list sans">
            <li></li>
          </ul>
          <!-- /画像コメント -->

          <!-- サムネイル画像 -->
          <ul class="car-content-in-thumb-list of">
            <li v-for="path in data.imagePaths" :key="path">
              <img :src="path" width="75" height="75">
            </li>
          </ul>
          <!-- /サムネイル画像 -->

          <ul class="car-content-in-info-list of sans">
            <li><span>頭金0円</span></li>
            <li><span>ボーナス加算なし</span></li>
            <li><span>自動車保険込</span></li>
          </ul>

          <div class="car-content-in-price sans">
            6カ月契約<span class="text">月額 <span class="price">{{ Number(data.prices.price).toLocaleString() }}</span>円（税込）</span>
          </div>

          <div class="car-content-in-price-2 sans">
              支払総額<span class="text"><span class="price">{{ Number(Number(data.prices.price) * 6).toLocaleString() }}</span>円（税込）</span>
            </div>

          <!-- 誘導ボタン -->
          <ul class="car-content-in-btn-list sans of">
            <li class="back"><a @click="router.back()" >戻る</a></li>
            <li class="contact" v-if="Number(data.status) === 0"><router-link :to="`/apply/input1/${data.chassisNumber}`">{{ statusText[Number(data.status)] }}</router-link></li>
            <li class="none" v-else><a>{{ statusText[Number(data.status)] }}</a></li>
          </ul>
          <!-- /誘導ボタン -->

          <div class="contact-table-box pc tab">
            <table class="contact-table">
              <tr>
                <th class="th-1">年式</th>
                <th class="th-2">走行距離</th>
                <th class="th-3">排気量</th>
                <th class="th-4">修復歴</th>
              </tr>
              <tr>
                <td class="td-1">{{ formatYearMonth(data.firstYear)[0] }}年</td>
                <td class="td-2">{{ Math.floor(Number(data.milage) / 1000) / 10 }}万km</td>
                <td class="td-3">{{ Number(data.displacement) }}cc</td>
                <td class="td-4">{{ data.repairHistory }}</td>
              </tr>
            </table>
          </div>

          <div class="car-content-shop sans">
            取扱店舗：（株）{{ data.shop?.shopName }}　{{ data.shop?.baseName }}
          </div>

          <div class="contact-table-box mobi">
            <table class="contact-table">
              <tr>
                <th class="th-1">年式</th>
                <th class="th-2">走行距離</th>
              </tr>
              <tr>
                <td class="td-1">{{ formatYearMonth(data.firstYear)[0] }}年</td>
                <td class="td-2">{{ Math.floor(Number(data.milage) / 1000) / 10 }}万km</td>
              </tr>
              <tr>
              <th class="th-3">排気量</th>
              <th class="th-4">修復歴</th>
              </tr>
              <tr>
                <td class="td-3">{{ Number(data.displacement) }}cc</td>
                <td class="td-4">{{ data.repairHistory }}</td>
              </tr>
            </table>
          </div>

          <!-- car-content-in-box -->
          <div class="car-content-in-box">

            <div class="car-content-in-box-title sans">
              車両品質評価
            </div>

            <!-- of -->
            <div class="of">

              <div class="car-content-in-box-evaluation">
                <span class="text">総合評価</span>
                <span class="big">{{ data.score }}</span>
              </div>

              <div class="car-content-in-box-evaluation-in of sans">
                <p>{{ scoreComments[data.score] ?? '' }}</p>
              </div>

            </div>
            <!-- /of -->

            <table class="car-content-in-box-tb sans pc tab">
              <tr>
                <th class="th-1">走行</th>
                <td class="td-1">{{ data.run }}</td>
                <th class="th-2">内装</th>
                <td class="td-2">{{ data.interior }}</td>
              </tr>
              <tr>
                <th class="th-1">外装</th>
                <td class="td-1">{{ data.exterior }}</td>
              </tr>
            </table>

            <table class="car-content-in-box-tb sans mobi">
              <tr>
                <th class="th-1">走行</th>
                <td class="td-1">{{ data.run }}</td>
              </tr>
              <tr>
                <th class="th-1">内装</th>
                <td class="td-1">{{ data.interior }}</td>
              </tr>
              <tr>
                <th class="th-1">外装</th>
                <td class="td-1">{{ data.exterior }}</td>
              </tr>
            </table>

            <!-- of -->
            <div class="of">
              <div class="car-content-in-box-certificate sans">
              <a :href="data.certificatePath" class="car-content-in-box-certificate-btn sans">
                車両状態証明書を見る
              </a>
              <p>車両状態証明書は、表示項目・方法、運用体制について、一般社団法人自動車公正取引協議会の定める基準を満たした「スズキ認定中古車制度」に基づき作成したものです</p>
            </div>
            </div>
            <!-- /of -->

          </div>
          <!-- /car-content-in-box -->

          <!-- car-content-in-main -->
          <div class="car-content-in-main sans">

            <!-- 車両情報 -->
            <dl class="dl-1">
              <dt>車両情報</dt>
              <dd>
                <!-- PC・タブレット用 -->
                <table class="car-content-in-main-dl-dd-tb pc tab">
                  <tr>
                    <th>年式</th>
                    <td>{{ formatYearMonth(data.firstYear)[0] }}年{{ formatYearMonth(data.firstYear)[1] }}月</td>
                    <th>走行距離</th>
                    <td>{{ Number(data.milage).toLocaleString() }}km</td>
                  </tr>
                  <tr>
                    <th>修理歴</th>
                    <td>{{ data.repairHistory }}</td>
                    <th>車検</th>
                    <td>{{ formatYearMonth(data.nextCarInspectionYearMonth)[0] }}年{{ formatYearMonth(data.nextCarInspectionYearMonth)[1] }}月</td>
                  </tr>
                  <tr>
                    <th>カラー</th>
                    <td>{{ data.colorName }}</td>
                    <th>乗車定員</th>
                    <td>{{ data.item?.capacity }}人</td>
                  </tr>
                  <tr>
                    <th>駆動</th>
                    <td>{{ data.drive }}</td>
                    <th>ミッション</th>
                    <td>{{ data.transmission }}</td>
                  </tr>
                  <tr>
                    <th>ドア数</th>
                    <td>{{ data.numberOfDoors }}</td>
                    <th>車体末尾番号</th>
                    <td>{{ String(data.maskedChassisNumber) }}</td>
                  </tr>
                </table>
                <!-- /PC・タブレット用 -->

                <!-- スマホ用 -->
                <table class="car-content-in-main-dl-dd-tb mobi">
                  <tr>
                    <th>年式</th>
                    <td>{{ formatYearMonth(data.firstYear)[0] }}年{{ formatYearMonth(data.firstYear)[1] }}月</td>
                  </tr>
                  <tr>
                    <th>走行距離</th>
                    <td>{{ Number(data.milage).toLocaleString() }}km</td>
                  </tr>
                  <tr>
                    <th>修理歴</th>
                    <td>{{ data.repairHistory }}</td>
                  </tr>
                  <tr>
                    <th>車検</th>
                    <td>{{ formatYearMonth(data.nextCarInspectionYearMonth)[0] }}年{{ formatYearMonth(data.nextCarInspectionYearMonth)[1] }}月</td>
                  </tr>
                  <tr>
                    <th>カラー</th>
                    <td>{{ data.colorName }}</td>
                  </tr>
                  <tr>
                    <th>乗車定員</th>
                    <td>{{ data.item?.capacity }}人</td>
                  </tr>
                  <tr>
                    <th>駆動</th>
                    <td>{{ data.drive }}</td>
                  </tr>
                  <tr>
                    <th>ミッション</th>
                    <td>{{ data.transmission }}</td>
                  </tr>
                  <tr>
                    <th>ドア数</th>
                    <td>{{ data.numberOfDoors }}</td>
                  </tr>
                  <tr>
                    <th>車体末尾番号</th>
                    <td>{{ String(data.maskedChassisNumber) }}</td>
                  </tr>
                </table>
                <!-- /スマホ用 -->
              </dd>
            </dl>
            <!-- /車両情報 -->

            <!-- 装備 -->
            <dl class="dl-2">
              <dt>装備</dt>
              <dd>
                <ul class="car-content-in-main-dl-dd-info-list of">
                  <li :class="{ off: !Boolean(data.item.airbag) }"><span>エアバッグ</span></li>
                  <li :class="{ off: !Boolean(data.item.slidedoor) }"><span>スライドドア</span></li>
                  <li :class="{ off: !Boolean(data.item.idlingStop) }"><span>アイドリングストップ</span></li>
                  <li :class="{ off: !Boolean(data.item.abs) }"><span>ABS</span></li>
                  <li :class="{ off: !Boolean(data.item.antiTheftSystem) }"><span>盗難防止システム</span></li>
                  <li :class="{ off: !Boolean(data.item.allSeazonTire) }"><span>オールシーズンタイヤ</span></li>
                </ul>
              </dd>
            </dl>
            <!-- /装備 -->

            <!-- 安全性能 -->
            <dl class="dl-3">
              <dt>安全性能</dt>
              <dd>
                <ul class="car-content-in-main-dl-dd-info-list of">
                  <li :class="{ off: !Boolean(data.item.eStabilityControl) }"><span>横滑り防止装置</span></li>
                  <li :class="{ off: !Boolean(data.item.collisionSafetyBody) }"><span>衝突安全ボディ</span></li>
                  <li :class="{ off: !Boolean(data.item.autoLight) }"><span>オートライト</span></li>
                  <li :class="{ off: !Boolean(data.item.collisionDamageMitigationBrake) }"><span>衝突被害軽減ブレーキ</span></li>
                  <li :class="{ off: !Boolean(data.item.backBrakeSupport) }"><span>後退時ブレーキサポート</span></li>
                  <li :class="{ off: !Boolean(data.item.misstartSuppression) }"><span>誤発進抑制機能</span></li>
                  <li :class="{ off: !Boolean(data.item.laneDeviationControl) }"><span>車線逸脱抑制機能</span></li>
                  <li :class="{ off: !Boolean(data.item.laneDeviationAlerm) }"><span>車線逸脱警報機能</span></li>
                  <li :class="{ off: !Boolean(data.item.staggerAlarm) }"><span>ふらつき警報機能</span></li>
                  <li :class="{ off: !Boolean(data.item.adaptiveCruiseControl) }"><span>アダプティブクルーズ<br>コントロール</span></li>
                  <li :class="{ off: !Boolean(data.item.signRecognition) }"><span>標識認識機能</span></li>
                  <li :class="{ off: !Boolean(data.item.headupDisplay) }"><span>ヘッドアップ<br>ディスプレイ</span></li>
                  <li :class="{ off: !Boolean(data.item.highBeamAssist) }"><span>ハイビームアシスト</span></li>
                  <li :class="{ off: !Boolean(data.item.precedingVehicleStartNotification) }"><span>先行車発進<br>お知らせ機能</span></li>
                  <li :class="{ off: !Boolean(data.item.blindSpotMonitor) }"><span>ブラインドスポットモニター</span></li>
                  <li :class="{ off: !Boolean(data.item.rearCrossTrafficAlert) }"><span>リヤクロス<br>トラフィックアラート</span></li>
                  <li :class="{ off: !Boolean(data.item.omnidirectionalMonitorCamera) }"><span>全方位モニター用<br>カメラ</span></li>
                  <li :class="{ off: !Boolean(data.item.laneKeepSupport) }"><span>車線維持支援機能</span></li>
                  <li :class="{ off: !Boolean(data.item.backCamera) }"><span>バックカメラ</span></li>
                </ul>
              </dd>
            </dl>
            <!-- /安全性能 -->

            <!-- オプション装備（有償） -->
            <dl class="dl-4">
              <dt>オプション装備（有償）</dt>
              <dd>
                <ul class="car-content-in-main-dl-dd-list">
                  <li v-if="Boolean(data.enableWinterTireOption)">スタッドレスタイヤ</li>
                  <li v-else>なし</li>
                </ul>
              </dd>
            </dl>
            <!-- /オプション装備（有償） -->

          </div>
          <!-- /car-content-in-main -->

          <!-- car-content-in-info-box -->
          <div class="car-content-in-info-box">

            <center>
              <div class="car-content-in-info-box-title sans">
                取扱店舗
              </div>
            </center>

            <div class="car-content-in-info-box-area-title sans">
              （株）{{ data.shop?.shopName }}　{{ data.shop?.baseName }}
            </div>

            <table class="car-content-in-info-box-tb">
              <tr>
                <th>住所</th>
                <td>〒{{ data.shop?.postalCode }} {{ data.shop?.prefecture }}{{ data.shop?.city }}{{ data.shop?.address }}</td>
              </tr>
              <tr>
                <th>電話番号</th>
                <td>{{ data.shop?.phoneNumber }}</td>
              </tr>
              <tr>
                <th>ホームページ</th>
                <td><a :href="data.shop?.url" target="_blank">{{ data.shop?.url }}</a></td>
              </tr>
              <tr>
                <th>営業時間</th>
                <td>{{ data.shop?.businessHours }}</td>
              </tr>
              <tr>
                <th>定休日</th>
                <td>{{ data.shop?.regularHoliday }}
                </td>
              </tr>
            </table>

          </div>
          <!-- /car-content-in-info-box -->

          <!-- 誘導ボタン -->
          <ul class="car-content-in-btn-list sans of">
            <li class="back"><a @click="router.back()" >戻る</a></li>
            <li class="contact" v-if="Number(data.status) === 0"><router-link :to="`/apply/input1/${data.chassisNumber}`">{{ statusText[Number(data.status)] }}</router-link></li>
            <li class="none" v-else><a>{{ statusText[Number(data.status)] }}</a></li>
          </ul>
          <!-- /誘導ボタン -->

        </div>
        <!-- /車種詳細 -->

      </div>
      <div class="wrapper" v-else>
        <center>読込中...</center>
      </div>
    </div>
    <!-- /car-content -->
  </page>
</template>
<!-- eslint-enable no-irregular-whitespace -->

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from "vue-router";
// import globalScript from '@/global';
import Page from '@/components/Page.vue';
import scripts from '@/assets/car-detail.js';

import { fetchStockDetail } from '@/api/car';
import { StockDetail } from '@/api/car/type';



export default defineComponent({
  components: {
    Page,
  },
  setup () {
    const route = useRoute();
    const router = useRouter();
    const chassisNumber = String(route.params.chassisNumber);
    const scoreComments = ref(comments);
    const loading = ref(true);
    const data = ref<StockDetail>();

    onMounted(async () => {
      try {
        const fetched = await fetchStockDetail(chassisNumber);
        // console.log(fetched);
        data.value = fetched.data;
        loading.value = false;
        setTimeout(() => {
          scripts.carDetailScript(data?.value?.imageComments || []);
        }, 100);
      } catch (e) {
        console.error(e);
        router.push('/no-data');
      }
    });

    const statusText = {
      0: '申し込む',
      1: '商談中',
      2: '契約手続中',
      3: '契約手続中',
      4: '利用中',
      5: '準備中',
    };

    return {
      router,
      loading,
      data,
      scoreComments,
      formatYearMonth,
      statusText,
    };
  },
});

const comments = {
  'S': 'ほぼ新車の状態で、内外装、無傷・無補修の状態です。',
  '6': '内外装、無傷、無補修の状態です。',
  '5': '目立たない傷、凹みなどが少しあるが、概ね良好な状態です。',
  '4.5': '小さなキズ、凹み・軽微な修理跡があるが、そのまま加修せずに十分に乗れる状態です。',
  '4': '目立つ傷、凹みなどが少しあり、加修が必要と思われる箇所が数カ所ある状態です。',
  '3.5': '大小の加修を必要とする箇所が数カ所ある状態又は外板②適用車です。',
  '3': '大小の加修を必要とする箇所が多数ある状態です。',
  '2': '加修を必要とする箇所が車両全体にある状態です。',
  '1': '消化材散布車・冠水車（歴車を含む）',
  'R': '修復歴車',
};

const formatYearMonth = (yearMonth: string): string[] => {
  const out = [];
  const source = String(yearMonth);
  out[0] = source.slice(0,4);
  out[1] = source.slice(4,6).replace(/^0/, '');
  return out;
};
</script>

<style lang="scss" scoped>
  .header-logo {
    margin-top: 80px;
  }
</style>